"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlayCircleOutline = {
    name: 'play-circle',
    theme: 'outline',
    nameWithTheme: 'play-circle-o',
    tag: 'svg',
    attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        class: 'icon',
        viewBox: '0 0 1024 1024'
    },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
            },
            children: []
        },
        {
            tag: 'path',
            attrs: {
                d: 'M719.4 499.1l-296.1-215c-10.6-7.7-25.3-.2-25.3 12.9v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215c8.8-6.4 8.8-19.4 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'
            },
            children: []
        }
    ]
};
exports.default = PlayCircleOutline;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/outline/PlayCircleOutline.js
// module id = 609
// module chunks = 0 1